import { lazy } from 'react';

const Login = lazy(() => import('@/pages/Login'));
const AdminHome = lazy(() => import('@/modeuls/admin/pages/AdminHome'));
const TreatmentsTable = lazy(() => import('@/modeuls/admin/pages/Treatment/TreatmentsTable'));
const TreatmentForm = lazy(() => import('@/modeuls/admin/pages/Treatment/TreatmentForm'));
const UpdateTreatment = lazy(() => import('@/modeuls/admin/pages/Treatment/UpdateTreatmentForm'));
const ViewTreatment = lazy(() => import('@/modeuls/admin/pages/Treatment/TreatmentView'));
const CoordinatorsTable = lazy(() => import('@/modeuls/admin/pages/Coordinator/CoordinatorsTable'));
const CoordinatorForm = lazy(() => import('@/modeuls/admin/pages/Coordinator/CoordinatorForm'));
const UpdateCoordinator = lazy(() => import('@/modeuls/admin/pages/Coordinator/UpdateCoordinatorForm'));


const CoordinatorHomePage = lazy(() => import('@/modeuls/coordinator/pages/Home'));
const TreatmentCourseForm = lazy(() => import('@/modeuls/coordinator/pages/TreatmentCourseForm'));
const UpdateTreatmentCourseForm = lazy(() => import('@/modeuls/coordinator/pages/UpdateTreatmentCourseForm'));
const ViewTreatmentCourse = lazy(() => import('@/modeuls/coordinator/pages/TreatmentCourseView'));
const PatientTreatmentCourseView = lazy(() => import('@/modeuls/patient/pages/PatientTreatmentCourseView'));
const AlreadySignedDocument = lazy(() => import('@/components/DocumentSigned'));
export {
    Login,
    AdminHome,
    TreatmentsTable,
    TreatmentForm,
    UpdateTreatment,
    ViewTreatment,
    CoordinatorsTable,
    CoordinatorForm,
    UpdateCoordinator,
    CoordinatorHomePage,
    TreatmentCourseForm,
    UpdateTreatmentCourseForm,
    ViewTreatmentCourse,
    PatientTreatmentCourseView,
    AlreadySignedDocument
}